/**
 * Admin copy for the visual wave (V-ADMIN, D510): the drawer-menu names of the shared shell, the load-failure and retry
 * sentences of the tables, the plain-language replacements for raw server codes, and the translated labels of the status
 * and role enums that used to be shown as raw codes ("ACTIVE", "IN_PROGRESS").
 *
 * Kept in its own file; `messages.ts` spreads it into the catalog and asserts that no id collides. Same four base
 * languages, one entry per id. Neutral: no country, law or language is named as a default.
 */
type Entry = Readonly<{ pt: string; en: string; es: string; it: string }>;

const e = (pt: string, en: string, es: string, it: string): Entry => ({ pt, en, es, it });

export const VISUAL_DICT: Readonly<Record<string, Entry>> = {
  // ---- shell ------------------------------------------------------------------------------------------------------
  'header.openMenu': e('Abrir menu', 'Open menu', 'Abrir menú', 'Apri il menu'),
  'header.closeMenu': e('Fechar menu', 'Close menu', 'Cerrar menú', 'Chiudi il menu'),

  'dir.drawer.tabs': e('Seções do registro', 'Record sections', 'Secciones del registro', 'Sezioni della scheda'),

  // ---- enum labels (a server code is never shown raw) ----------------------------------------------------------
  // ---- error codes in plain words (the `{code}` of an error sentence is mapped through these) ---------------------
  // ---- a masked phone's audited "show" action (owner 2026-10-13; RevealContact) ----------------------------------------
  'contact.reveal': e('Mostrar telefone', 'Show phone', 'Mostrar teléfono', 'Mostra telefono'),
  'contact.reveal.busy': e('Mostrando…', 'Showing…', 'Mostrando…', 'Mostrando…'),
  'contact.reveal.failed': e('Não foi possível mostrar o telefone.', 'The phone could not be shown.', 'No se pudo mostrar el teléfono.', 'Impossibile mostrare il telefono.'),
  'contact.hide': e('Ocultar telefone', 'Hide phone', 'Ocultar teléfono', 'Nascondi telefono'),
  'contact.reveal.note': e('Fica registrado na auditoria da conta.', 'Recorded in the account audit.', 'Queda registrado en la auditoría de la cuenta.', 'Viene registrato nell’audit dell’account.'),

  // ---- load states ------------------------------------------------------------------------------------------------
  'ui.retry': e('Tentar de novo', 'Try again', 'Intentar de nuevo', 'Riprova'),
  // ---- a long identifier's copy action (CodeRef, D619) ----
  'ui.copy': e('Copiar código', 'Copy code', 'Copiar código', 'Copia codice'),
  'ui.copied': e('Copiado', 'Copied', 'Copiado', 'Copiato'),
  'ui.loadFailed': e('Não foi possível carregar esta lista.', 'This list could not be loaded.', 'No se pudo cargar esta lista.', 'Impossibile caricare questo elenco.'),
};
